/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ session: NonNullable<unknown> }} Plan_Build_Day_Removed_ToastInputs */

const en_us2_plan_build_day_removed_toast = /** @type {(inputs: Plan_Build_Day_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} deleted`)
};

const pt_br2_plan_build_day_removed_toast = /** @type {(inputs: Plan_Build_Day_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} excluído`)
};

const es_419_plan_build_day_removed_toast = /** @type {(inputs: Plan_Build_Day_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} eliminado`)
};

const pt_pt2_plan_build_day_removed_toast = /** @type {(inputs: Plan_Build_Day_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} eliminado`)
};

const fr_fr2_plan_build_day_removed_toast = /** @type {(inputs: Plan_Build_Day_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} supprimée`)
};

const de_de2_plan_build_day_removed_toast = /** @type {(inputs: Plan_Build_Day_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} gelöscht`)
};

const it_it2_plan_build_day_removed_toast = /** @type {(inputs: Plan_Build_Day_Removed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.session} eliminato`)
};

/**
* | output |
* | --- |
* | "{session} deleted" |
*
* @param {Plan_Build_Day_Removed_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_day_removed_toast = /** @type {((inputs: Plan_Build_Day_Removed_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Day_Removed_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_day_removed_toast(inputs)
	if (locale === "es-419") return es_419_plan_build_day_removed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_day_removed_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_day_removed_toast(inputs)
	if (locale === "de-DE") return de_de2_plan_build_day_removed_toast(inputs)
	if (locale === "it-IT") return it_it2_plan_build_day_removed_toast(inputs)
	return en_us2_plan_build_day_removed_toast(inputs)
});
export { plan_build_day_removed_toast as "plan-build.day_removed_toast" }